module.exports = __webpack_public_path__ + "img/mais.aafcf13d.svg";